import { Thunk } from ".";
import { List } from "immutable";
import { createAction } from "redux-actions";
import * as AlertActions from "./NotificationActions";
import * as M from "../models";
import { Api } from "../services/Api";

const prefix = "ABSTRACTGRADING_";

export class Constants {
    public static LOADING_ABSTRACT = prefix + "LOADING_ABSTRACT";
    public static LOADING_LIST_ABSTRACTS = prefix + "LOADING_LIST_ABSTRACTS";
    public static LOADING_TYPE = prefix + "LOADING_TYPE";
    public static UPDATED_ABSTRACTS = prefix + "UPDATED_ABSTRACTS";
    public static UPDATED_LIST_ABSTRACTS = prefix + "UPDATED_LIST_ABSTRACTS";
    public static UPDATED_REVIEWER_STATS = prefix + "UPDATED_REVIEWER_STATS";
    public static UPDATED_TYPES = prefix + "UPDATED_TYPES";
}

interface LoadingAbstractPayload {
    guid: string;
    loading: boolean;
}

interface LoadingTypePayload {
    typeId: number;
    loading: boolean;
}

export const loadAbstract = (guid: string): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.users.abstractGrading.abstract.withUrlParams({ guid }));

    if (result.isSuccess && result.data)
        dispatch(updateAbstract(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingAbstract(guid, false));
};

export const loadListAbstracts = (): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.users.abstractGrading.abstracts);

    if (result.isSuccess && result.data)
        dispatch(updateListAbstracts(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingListAbstracts(false));
};

export const loadReviewerStats = (): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const result = await api.get(Api.endpoints.users.abstractGrading.reviewerStats);

    if (result.isSuccess && result.data)
        dispatch(onReviewerStatsUpdated(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));
};

export const loadType = (typeId: number): Thunk => async (dispatch, getState) => {
    const state = getState();
    const api = new Api(state);
    const qp = { queryParams: { forGrading: true }};
    const result = await api.get(Api.endpoints.abstract.type.withUrlParams({ id: typeId }), qp);

    if (result.isSuccess && result.data)
        dispatch(updateType(result.data));
    else
        dispatch(AlertActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));

    dispatch(toggleLoadingType(typeId, false));
};

export const updateAbstract = (item: M.Abstract.AbstractForGrader): Thunk => async (dispatch, getState) => {
    dispatch(updateAbstracts([item]));
};

export const updateAbstracts = (list: M.Abstract.AbstractForGrader[] | List<M.Abstract.AbstractForGrader>): Thunk => async (dispatch, getState) => {
    let abstracts = getState().abstractGrading.abstracts;
    const updatedList: M.Abstract.AbstractForGrader[] = !Array.isArray(list)
        ? list.toArray()
        : list;

    updatedList.map((a: M.Abstract.AbstractForGrader) => {
        const idx = abstracts.findIndex((x: M.Abstract.AbstractForGrader) => x.id === a.id);
        abstracts = idx > -1
            ? abstracts.set(idx, a)
            : abstracts.push(a);
    });

    dispatch(onAbstractsUpdated(abstracts));
};

export const updateListAbstract = (item: M.Abstract.AbstractGraderListItem): Thunk => async (dispatch, getState) => {
    dispatch(updateListAbstracts([item]));
};

export const updateListAbstracts = (list: M.Abstract.AbstractGraderListItem[] | List<M.Abstract.AbstractGraderListItem>): Thunk => async (dispatch, getState) => {
    let abstracts = getState().abstractGrading.listAbstracts;
    const updatedList: M.Abstract.AbstractGraderListItem[] = !Array.isArray(list)
        ? list.toArray()
        : list;

    updatedList.map((a: M.Abstract.AbstractGraderListItem) => {
        const idx = abstracts.findIndex((x: M.Abstract.AbstractGraderListItem) => x.id === a.id);
        abstracts = idx > -1
            ? abstracts.set(idx, a)
            : abstracts.push(a);
    });

    dispatch(onListAbstractsUpdated(abstracts));
};

export const updateType = (type: M.Abstract.AbstractType): Thunk => async (dispatch, getState) => {
    dispatch(updateTypes([type]));
};

export const updateTypes = (updatedTypes: M.Abstract.AbstractType[] | List<M.Abstract.AbstractType>): Thunk => async (dispatch, getState) => {
    let types = getState().abstractGrading.types;
    const _updatedTypes: M.Abstract.AbstractType[] = !Array.isArray(updatedTypes)
        ? updatedTypes.toArray()
        : updatedTypes;

    _updatedTypes.map((type: M.Abstract.AbstractType) => {
        const idx = types.findIndex((x: M.Abstract.AbstractType) => x.id === type.id);
        types = idx > -1
            ? types.set(idx, type)
            : types.push(type);
    });

    dispatch(onTypesUpdated(types));
};

export const onAbstractsUpdated = createAction<List<M.Abstract.AbstractForGrader>, List<M.Abstract.AbstractForGrader>>(
    Constants.UPDATED_ABSTRACTS, (abstracts) => (abstracts),
);

export const onListAbstractsUpdated = createAction<List<M.Abstract.AbstractGraderListItem>, List<M.Abstract.AbstractGraderListItem>>(
    Constants.UPDATED_LIST_ABSTRACTS, (abstracts) => (abstracts),
);

export const onReviewerStatsUpdated = createAction<M.Abstract.ReviewerStats, M.Abstract.ReviewerStats>(
    Constants.UPDATED_REVIEWER_STATS, (abstracts) => (abstracts),
);

export const onTypesUpdated = createAction<List<M.Abstract.AbstractType>, List<M.Abstract.AbstractType>>(
    Constants.UPDATED_TYPES, (types) => (types),
);

export const toggleLoadingAbstract = createAction<LoadingAbstractPayload, string, boolean>(
    Constants.LOADING_ABSTRACT, (guid, loading) => ({ guid, loading }),
);

export const toggleLoadingListAbstracts = createAction<boolean, boolean>(
    Constants.LOADING_LIST_ABSTRACTS, (loading) => (loading),
);

export const toggleLoadingType = createAction<LoadingTypePayload, number, boolean>(
    Constants.LOADING_TYPE, (typeId, loading) => ({ typeId, loading }),
);



// WEBPACK FOOTER //
// ./src/actions/AbstractGradingActions.ts